import type { FaireProductEntity } from "../../entity_types/product";

export const p_uwsm4djtvn: FaireProductEntity = {
  token: "p_uwsm4djtvn",
  type: "product",
  name: "Tea House Soy Wax Candle [tea/jasmine/lemon]",
  brandToken: "b_8qg6mcqebk",
  brandName: "Palmoire Home Fragrance",
  imageUrl:
    "https://cdn.faire.com/fastly/90f99ad4091b4a04ff433e385fe1f5e62803116d51d2530bb195b856e95fbf6e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/de2721a485c20acac91f0edc321f44011f60db3099328df1929e3534786e6868.jpeg",
    "https://cdn.faire.com/fastly/3b0a3ee5ffa451f8e07e640d4bf0aca5b709b02456ea37da76341f6885e6802c.jpeg",
    "https://cdn.faire.com/fastly/7edd2ad33f35d133d563a6912836de9985a1b720c0d2b6206ab6969d12f269e4.jpeg",
    "https://cdn.faire.com/fastly/44ad9fba76504d902a482b6f33053af8eaa0c76ce585b7a961716d01a1878e38.jpeg",
    "https://cdn.faire.com/fastly/ec0aa7b2192440ee7e501a3c68acdc4c81dac1eb0ef32ae2c14afbbc1a9f18e3.jpeg",
    "https://cdn.faire.com/fastly/c5887414a8e73686820e307cb9bbeb49b70528937c7773268c3d0c37e9ffad02.jpeg",
    "https://cdn.faire.com/fastly/eb16cdfa289e9e6a329d911ce6a40abdde4cb2af4c618cc16533bed236bc618d.jpeg",
  ],
  priceDollars: 9.6,
  description:
    '• Only the 2.3oz has gemstones inside the candle\n• Our tester has the same size and package as the original product\n\nTransform your space with the Tea House Soy Wax Candle. Invigorating green tea blends seamlessly with citrus and florals to create a soothing ambiance. Ideal for relaxation and letting go of worries.\n\n• Top Notes: caraway seed, rhubarb, lemon, orange\n• Middle Notes: green tea, jasmine, carnation, fennel\n• Base Notes: amber, oak, musk, mint\n\n-----\n\nMade of soy-based wax and scented with fragrance oil.\n\n𝐖𝐞𝐢𝐠𝐡𝐭\n• Standard: 4.9 Oz. | 140 G\n• Mini: 2.3 Oz. | 65 G\n\n𝐃𝐢𝐦𝐞𝐧𝐬𝐢𝐨𝐧𝐬\n• Standard: Height 3.23"|8.2cm Diameter 2.76"|7cm\n• Mini: Height 1.93"|4.9cm Diameter 2.91"|7.4cm\n\n𝐁𝐮𝐫𝐧𝐢𝐧𝐠 𝐓𝐢𝐦𝐞\n• Standard: up to 22 hours\n• Mini: up to 10 hours\n\nSoy Candle, Aromatherapy, Home Fragrance, Essential Oil, Jar, Natural, Luxury, Calming, Wedding Gift, Birthday Gift, Scented Candle, Decorative, Romantic, Boutique, Unique gifts',
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:54.985Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
